import type { ColumnConfig } from '../../../../hooks';

/** Default column configuration for the coaches table */
export const COACH_DEFAULT_COLUMNS: ColumnConfig[] = [
  { id: 'coach', label: 'Coach', visible: true, sortable: true },
  { id: 'satisfaction', label: 'Satisfaction', visible: true, sortable: false },
  { id: 'region', label: 'Region', visible: true, sortable: true },
  { id: 'timezone', label: 'Timezone', visible: true, sortable: true },
  { id: 'availability', label: 'Availability', visible: true, sortable: true },
  { id: 'groups', label: 'Groups', visible: true, sortable: false },
  { id: 'one_on_one', label: '1:1', visible: true, sortable: true },
  { id: 'workshop', label: 'Workshop', visible: true, sortable: true },
  { id: 'contract', label: 'Contract RCVD', visible: true, sortable: true },
];

/** Get minimum width for a coach column based on its id */
export function getCoachColumnMinWidth(columnId: string): number | undefined {
  switch (columnId) {
    case 'coach': return 240;
    case 'satisfaction': return 120;
    case 'region': return 120;
    case 'timezone': return 140;
    case 'availability': return 150;
    case 'groups': return 160;
    case 'one_on_one': return 80;
    case 'workshop': return 100;
    case 'contract': return 130;
    default: return 120;
  }
}
